import { Divider, Paper } from '@mui/material';
import { MemreButton, MemreFlexBox, MemreRTE } from 'components/core';
import Hotspot from './Hotspot';

export default function HotspotQuestion({ hotspot, url }) {
  const { id } = hotspot;
  const disabled = id.includes('placeholder');

  return (
    <Paper
      component="form"
      key={id}
      sx={{
        p: '2px 8px 2px 4px',
        mb: 2,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        border: '1px solid #767676',
        opacity: disabled ? 0.3 : 1,
        pointerEvents: disabled ? 'none' : 'auto',
        width: '100%',
        height: hotspot.open ? 'auto' : '100px',
      }}
    >
      <MemreFlexBox direction="row" gap={1} sx={{ width: '100%' }}>
        <MemreFlexBox direction="column" sx={{ flex: 1 }}>
          <MemreRTE
            initialContent={hotspot.text}
            onUpdate={hotspot.updateText}
            placeholder="Question Text - eg. Where is the mitochondria?"
            id={`$answer-${id}`}
          />
          <Divider orientation="horizontal" />
          <div style={{ margin: '-6px 0' }}>
            <MemreRTE
              initialContent={hotspot.explanation}
              onUpdate={hotspot.updateExplanation}
              id={`$explanation-${hotspot.id}`}
              placeholder="Explain why this is the correct answer (optional)"
            />
          </div>
        </MemreFlexBox>
        <MemreFlexBox
          direction="column"
          align="center"
          justify="space-between"
          sx={{ p: 1, pl: 2, borderLeft: '1px solid #ddd' }}
        >
          <MemreButton variant="icon" iconName="chevronDown" onClick={hotspot.setOpen} />
          <MemreButton variant="icon" iconName="trash" onClick={hotspot.delete} />
        </MemreFlexBox>
      </MemreFlexBox>
      {hotspot.open && (
        <Hotspot url={url} onChange={hotspot.position} initialCoords={hotspot.region} key={hotspot.region} />
      )}
    </Paper>
  );
}
